export const VariantActionsCell = ({ row, table }) => {
  const meta = table.options.meta;
  const isExpanded = meta.expandedIndex === row.index;

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={() => meta.toggleExpand(row.index)}
        title={isExpanded ? "Close" : "Edit variant"}
        className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 hover:bg-pink-50 hover:text-pink-600 transition-colors"
      >
        <i className={`fa ${isExpanded ? "fa-chevron-up" : "fa-pencil"}`}></i>
      </button>
      <button
        type="button"
        onClick={() => meta.removeRow(row.index)}
        title="Delete variant"
        className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 hover:bg-red-50 hover:text-red-600 transition-colors"
      >
        <i className="fa fa-trash-o"></i>
      </button>
    </div>
  );
};